module.exports = __webpack_public_path__ + "img/toolbar-right.f189e7a8.png";